export enum CopyConfigTypes {
    EmailRules = 'EmailRules',
    StateRules = 'StateRules',
    Lists = 'Lists',
    Templates = 'Templates',
    TenantStatus = 'TenantStatus',
    FormFlow = 'FormFlow',
    Permissions = 'Permissions',
    PermissionGroups = 'PermissionGroups',
    PermissionGroupsTemplateFilters = 'PermissionGroupsTemplateFilters',
    Release = 'Release',
    ReleaseClone = 'ReleaseClone',
    Publish = 'Publish',
    RulesId = 'RulesId',
    ModuleConfig = 'ModuleConfig',
    ModuleRecordData = 'ModuleRecordData',
    Dashboards = 'Dashboards',
    Feeds = 'Feeds',
    Users = 'Users',
    HierarchyAndAttributes = 'HierarchyAndAttributes',
    UserHierarchyPermissions = 'UserHierarchyPermissions',
    FeatureFlags = 'FeatureFlags',
    SeverityMatrix = 'SeverityMatrix'
}
